import Doctordetailst1 from "./doctordetailst1";
import Doctordetailst2 from "./doctordetailst2";
import Sidebaradmin from "./sidebaradmin";


function Doctordetails() {

    return (
        <>
            <Sidebaradmin></Sidebaradmin>
            <Doctordetailst1></Doctordetailst1>
            <Doctordetailst2></Doctordetailst2>
        </>
    )
}
export default Doctordetails;